import { Translatable } from "@icc/shared/helpers";

/** Rynna górna */
export class TopRail {
    id: number;
    @Translatable({ model: 'Profiles' })
    name: string;
    /** Odstęp do prowadzenia [mm] */
    spaceToGuideMm: number;
    shutterTypes: number[];
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;
}
